import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { paymentApi } from '@formosa/shared/api/payment';
import { resolveImageUrl, resolveLocalizedDisplayName } from '../../constants/depositConstants';
import { useTranslation } from '../../i18n/LocaleContext';

function MerchantIcon({ image }) {
  const [broken, setBroken] = useState(false);
  const imageUrl = resolveImageUrl(image);

  if (!imageUrl || broken) {
    return <span>₿</span>;
  }

  return (
    <img
      src={imageUrl}
      alt=""
      onError={() => setBroken(true)}
    />
  );
}

export default function DepositMerchantListPage() {
  const navigate = useNavigate();
  const { locale, t } = useTranslation();
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    paymentApi
      .listDepositMerchants({ lang: locale })
      .then((rows) => {
        if (!cancelled) {
          setMerchants(Array.isArray(rows) ? rows : []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || t('deposit.loadMerchantsFailed'));
          setMerchants([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [locale, t]);

  function handleSelect(merchant) {
    if (merchant.kind === 'ONLINE') {
      navigate(`/deposit/online/${merchant.id}`, { state: { merchant } });
      return;
    }
    navigate('/deposit/offline', { state: { merchant } });
  }

  return (
    <div className="deposit-page">
      <header className="deposit-page__header">
        <button
          type="button"
          className="deposit-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          ‹
        </button>
        <h1>{t('deposit.title')}</h1>
        <span className="deposit-page__header-spacer" />
      </header>

      {loading && <p className="deposit-page__status">{t('common.loading')}</p>}
      {error && <p className="deposit-page__error">{error}</p>}

      {!loading && !error && (
        <ul className="deposit-merchant-list">
          {merchants.length === 0 ? (
            <li className="deposit-page__empty">{t('common.noData')}</li>
          ) : (
            merchants.map((merchant) => (
              <li key={`${merchant.kind}-${merchant.id}`}>
                <button
                  type="button"
                  className="deposit-merchant-item"
                  onClick={() => handleSelect(merchant)}
                >
                  <span className="deposit-merchant-item__icon" aria-hidden>
                    <MerchantIcon image={merchant.image} />
                  </span>
                  <span className="deposit-merchant-item__name">
                    {resolveLocalizedDisplayName(merchant.displayName, locale)}
                  </span>
                  <span className="deposit-merchant-item__arrow" aria-hidden>
                    ›
                  </span>
                </button>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
}
